import React, { useCallback, useRef, useState } from 'react';
import { AppConfirmModal } from '../components/ui';

/**
 * Remplace window.confirm par AppConfirmModal, en conservant un flux await.
 *
 * const { ask, modal } = useAppConfirm();
 * if (!(await ask({ title: 'Supprimer ?', message: '…', confirmVariant: 'danger' }))) return;
 */
export default function useAppConfirm() {
  const [config, setConfig] = useState(null);
  const resolverRef = useRef(null);

  const close = useCallback((result) => {
    const resolve = resolverRef.current;
    resolverRef.current = null;
    setConfig(null);
    resolve?.(result);
  }, []);

  const ask = useCallback((options = {}) => {
    if (resolverRef.current) {
      resolverRef.current(false);
      resolverRef.current = null;
    }
    return new Promise((resolve) => {
      resolverRef.current = resolve;
      setConfig({
        title: 'Confirmer',
        message: '',
        confirmLabel: 'Confirmer',
        confirmVariant: 'primary',
        confirmIcon: undefined,
        cancelLabel: 'Annuler',
        ...options,
      });
    });
  }, []);

  const modal = (
    <AppConfirmModal
      show={Boolean(config)}
      title={config?.title}
      confirmLabel={config?.confirmLabel}
      confirmVariant={config?.confirmVariant}
      confirmIcon={config?.confirmIcon}
      cancelLabel={config?.cancelLabel}
      onConfirm={() => close(true)}
      onClose={() => close(false)}
    >
      {typeof config?.message === 'string' || config?.message == null ? (
        <p className="mb-0" style={{ whiteSpace: 'pre-line' }}>{config?.message}</p>
      ) : config.message}
    </AppConfirmModal>
  );

  return { ask, modal };
}
